import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import Root from './root';

const Brzw = ({ store }) => (
  <IntlProvider locale="en">
    <Root store={store} />
  </IntlProvider>
);

Brzw.propTypes = {
  store: PropTypes.shape({}),
};

export default Brzw;
